import type { DataStreamBaseTileConfig, StreamDataColumnDefinition } from '@squaredup/data-streams';
import type { Dispatch, SetStateAction } from 'react';
import type { PartialDeep } from 'type-fest';
import { EditorSteps } from '../../../constants';
import type { StepWithCondition } from '../../../hooks/useTileEditorSteps';
import { countModifiedColumns } from './metadataEditor/MetadataEditorTileState';
import { DataStreamMetadata } from './DataStreamMetadata';

interface MetadataStepSublabelProps {
    dataStreamMetadata: PartialDeep<StreamDataColumnDefinition[]> | undefined;
    columnNames: string[];
}

interface DataStreamMetadataProps {
    config: DataStreamBaseTileConfig;
    setConfig: Dispatch<SetStateAction<DataStreamBaseTileConfig>>;
}

interface UseMetadataStepParameters {
    isLoading: boolean;
    hasDataStream: boolean;
    isConfigured: boolean;
    dataStreamMetadata: PartialDeep<StreamDataColumnDefinition[]> | undefined;
    columnNames: string[];
    config: DataStreamBaseTileConfig;
    setConfig: Dispatch<SetStateAction<DataStreamBaseTileConfig>>;
}

const MetadataStepSublabel: React.FC<MetadataStepSublabelProps> = ({ dataStreamMetadata, columnNames }) => {
    const numberOfModifiedColumns = countModifiedColumns(dataStreamMetadata, columnNames);
    return <>{numberOfModifiedColumns > 0 ? `${numberOfModifiedColumns} configured` : ''}</>;
};

/**
 * Create an object representing a metadata step.
 */
export const useMetadataStep = ({
    isLoading,
    hasDataStream,
    isConfigured,
    dataStreamMetadata,
    columnNames,
    config,
    setConfig
}: UseMetadataStepParameters): StepWithCondition<MetadataStepSublabelProps, DataStreamMetadataProps> => {
    const isEnabled = !isLoading && hasDataStream && isConfigured;

    return {
        name: EditorSteps.metadata,
        isEnabled,
        Sublabel: MetadataStepSublabel,
        sublabelProps: {
            dataStreamMetadata,
            columnNames
        },
        Content: DataStreamMetadata,
        contentProps: {
            config,
            setConfig
        }
    };
};
